import { ca } from '@cian/analytics';

export const trackCardClick = (label: 'card_header' | 'card_photo' | 'card_button') => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'to_card',
    category: 'ListingFavorites',
    label,
  });
};

export const trackRemoveFromFavorites = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'remove_from_favorites',
    category: 'favorite',
    label,
  });
};
